import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import ProductImage from './ProductImage';
import API_BASE_URL from '../config/apiConfig';

const NEWS_FLASH_ITEMS = [
  '100% Secure delivery without contacting the courier',
  'Supper Value Deals - Save more with coupons',
  'Trendy 25silver jewelry, save up 35% off today',
];

const Header = () => {
  const location = useLocation();
  const { cartItems, cartCount, cartTotal, removeFromCart, clearCart } = useCart();
  const { isAuthenticated, logout, user } = useAuth();
  const [activeNewsIndex, setActiveNewsIndex] = useState(0);
  const [menuCategories, setMenuCategories] = useState([]);

  const displayName = user?.UserName?.trim() || '';
  const accountLabel =
    isAuthenticated && displayName
      ? displayName.split(/\s+/)[0] || displayName
      : 'Account';

  const toSlug = (value) => (value || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

  const getCategoryLink = (category) => {
    const categorySlug = category?.Slug || toSlug(category?.CategoryName) || 'products';
    const params = new URLSearchParams();
    if (category?.CategoryName) {
      params.set('name', category.CategoryName);
    }
    params.set('categorySlug', categorySlug);
    return `/product-sub-category/${categorySlug}?${params.toString()}`;
  };

  const getSubCategoryLink = (subCategory, category) => {
    const subCategorySlug = subCategory?.Slug || toSlug(subCategory?.SubCategoryName) || 'products';
    const categorySlug = category?.Slug || toSlug(category?.CategoryName) || '';
    const params = new URLSearchParams();
    if (subCategory?.SubCategoryName) {
      params.set('name', subCategory.SubCategoryName);
    }
    params.set('subCategorySlug', subCategorySlug);
    if (categorySlug) {
      params.set('categorySlug', categorySlug);
    }
    return `/product-sub-category/${subCategorySlug}?${params.toString()}`;
  };

  useEffect(() => {
    const onScroll = () => {
      const stickyBar = document.querySelector('.sticky-bar');
      if (!stickyBar) return;
      if (window.scrollY < 200) {
        stickyBar.classList.remove('stick');
      } else {
        stickyBar.classList.add('stick');
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setActiveNewsIndex(0);
    const timer = window.setInterval(() => {
      setActiveNewsIndex((previous) => (previous + 1) % NEWS_FLASH_ITEMS.length);
    }, 3000);

    return () => window.clearInterval(timer);
  }, [location.pathname]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/product/categories`);
        const result = await response.json();
        if (response.ok && result?.success && Array.isArray(result.data) && result.data.length) {
          setMenuCategories(result.data);
        }
      } catch (error) {
        console.error('Failed to load categories for header menu:', error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <>
      <header className="header-area header-style-1 header-height-2">
        <div className="mobile-promotion">
          <span>Grand opening, <strong>up to 15%</strong> off all items. Only <strong>3 days</strong> left</span>
        </div>
        <div className="header-top header-top-ptb-1 d-none d-lg-block">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-4 col-lg-4">
                <div className="header-info">
                  {isAuthenticated && displayName ? (
                    <span>Hello, {displayName}!</span>
                  ) : null}
                </div>
              </div>
              <div className="col-xl-4 col-lg-4">
                <div className="text-center">
                  <div id="news-flash" className="d-inline-block">
                    <ul>
                      <li key={activeNewsIndex} className="animate__animated animate__fadeIn">
                        {NEWS_FLASH_ITEMS[activeNewsIndex]}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4">
                <div className="header-info header-info-right">
                  <ul>
                    <li><a href="page-about.htlm">About Us</a></li>
                    <li>
                      <Link to={isAuthenticated ? '/my-account' : '/login'}>
                        {isAuthenticated && displayName ? `Hi, ${displayName}` : 'My Account'}
                      </Link>
                    </li>
                    <li><a href="shop-order.html">Order Tracking</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="header-middle header-middle-ptb-1 d-none d-lg-block">
          <div className="container">
            <div className="header-wrap">
              <div className="logo logo-width-1">
                <a href="index.html"><img src="/assets/imgs/theme/logo.png" alt="logo" /></a>
              </div>
              <div className="header-right">
                <div className="search-style-2">

                </div>
                <div className="header-action-right">
                  <div className="header-action-2">
                    <div className="search-location">

                    </div>

                    <div className="header-action-icon-2">
                      <a
                        href="#cart"
                        className="mini-cart-icon"
                        onClick={(event) => event.preventDefault()}
                      >
                        <img alt="Nest" src="/assets/imgs/theme/icons/icon-cart.svg" />
                        <span className="pro-count blue">{cartCount}</span>
                      </a>
                      <button type="button" className="border-0 bg-transparent p-0"><span className="lable" style={{ color: '#7E7E7E' }}>Cart</span></button>
                      <div className="cart-dropdown-wrap cart-dropdown-hm2">
                        {cartItems.length ? (
                          <ul>
                            {cartItems.slice(0, 3).map((item) => (
                              <li key={item.ProductId}>
                                <div className="shopping-cart-img">
                                  <Link to={`/product-detail/${item.ProductId}`}><ProductImage alt={item.ProductName} src={item.DefaultImage} /></Link>
                                </div>
                                <div className="shopping-cart-title">
                                  <h4><Link to={`/product-detail/${item.ProductId}`}>{item.ProductName}</Link></h4>
                                  <h4><span>{item.quantity} × </span><i className="fa fa-inr fs-10" aria-hidden="true"></i>{item.Price}</h4>
                                </div>
                                <div className="shopping-cart-delete">
                                  <button
                                    type="button"
                                    className="border-0 bg-transparent p-0"
                                    onClick={() => removeFromCart(item.ProductId)}
                                  >
                                    <i className="fi-rs-cross-small"></i>
                                  </button>
                                </div>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <div className="p-3 text-center">Your cart is empty.</div>
                        )}
                        <div className="shopping-cart-footer">
                          <div className="shopping-cart-total">
                            <h4>Total <span><i className="fa fa-inr fs-10" aria-hidden="true"></i>{cartTotal.toLocaleString('en-IN')}</span></h4>
                          </div>
                          <div className="shopping-cart-button">
                            <Link
                              to="/shop-cart"
                              className="outline"
                              onClick={(event) => {
                                if (!cartItems.length) {
                                  event.preventDefault();
                                }
                              }}
                              aria-disabled={!cartItems.length}
                              style={!cartItems.length ? { pointerEvents: 'none', opacity: 0.6, cursor: 'not-allowed' } : undefined}
                            >
                              View cart
                            </Link>
                            <Link
                              to="/shop-checkout"
                              onClick={(event) => {
                                if (!cartItems.length) {
                                  event.preventDefault();
                                }
                              }}
                              aria-disabled={!cartItems.length}
                              style={!cartItems.length ? { pointerEvents: 'none', opacity: 0.6, cursor: 'not-allowed' } : undefined}
                            >
                              Checkout
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="header-action-icon-2">
                      <button type="button" className="border-0 bg-transparent p-0">
                        <img className="svgInject" alt="Nest" src="/assets/imgs/theme/icons/icon-user.svg" />
                      </button>
                      <button type="button" className="border-0 bg-transparent p-0"><span className="lable ml-0" style={{ color: '#7E7E7E' }}>{accountLabel}</span></button>
                      <div className="cart-dropdown-wrap cart-dropdown-hm2 account-dropdown">
                        <ul>
                          {isAuthenticated ? (
                            <>
                              {displayName ? (
                                <li className="px-3 py-2" style={{ pointerEvents: 'none', fontWeight: 600 }}>
                                  Hello, {displayName}!
                                </li>
                              ) : null}
                              <li>
                                <Link to="/my-account"><i className="fi fi-rs-user mr-10"></i>My Account</Link>
                              </li>
                              <li>
                                <Link to="/my-account"><i className="fi fi-rs-location-alt mr-10"></i>Order Tracking</Link>
                              </li>
                              <li>
                                <button
                                  type="button"
                                  className="border-0 bg-transparent p-0 d-flex align-items-center"
                                  onClick={() => {
                                    clearCart();
                                    logout();
                                  }}
                                >
                                  <i className="fi fi-rs-sign-out mr-10"></i>Sign out
                                </button>
                              </li>
                            </>
                          ) : (
                            <>
                              <li>
                                <Link to="/login"><i className="fi fi-rs-user mr-10"></i>My Account</Link>
                              </li>
                              <li>
                                <Link to="/register"><i className="fi fi-rs-user-add mr-10"></i>Register</Link>
                              </li>
                            </>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="header-bottom header-bottom-bg-color sticky-bar">
          <div className="container">
            <div className="header-wrap header-space-between position-relative">
              <div className="logo logo-width-1 d-block d-lg-none">
                <a href="index.html"><img src="/assets/imgs/theme/logo.png" alt="logo" /></a>
              </div>
              <div className="header-nav d-none d-lg-flex">

                <div className="main-menu main-menu-padding-1 main-menu-lh-2 d-none d-lg-block font-heading">
                  <nav>
                    <ul>
                      <li>
                        <Link className={location.pathname === '/' ? 'active' : ''} to="/">Home</Link>
                      </li>
                      {menuCategories.map((category) => (
                        <li key={category.CategoryId || category.CategoryName}>
                          <Link to={getCategoryLink(category)}>
                            {category.CategoryName}
                            {(category.SubCategories || []).length ? <i className="fi-rs-angle-down"></i> : null}
                          </Link>
                          {(category.SubCategories || []).length ? (
                            <ul className="sub-menu">
                              {category.SubCategories.map((subCategory) => (
                                <li key={subCategory.SubCategoryId || `${category.CategoryName}-${subCategory.SubCategoryName}`}>
                                  <Link to={getSubCategoryLink(subCategory, category)}>{subCategory.SubCategoryName}</Link>
                                </li>
                              ))}
                            </ul>
                          ) : null}
                        </li>
                      ))}
                    </ul>
                  </nav>
                </div>
              </div>
              <div className="hotline d-none d-lg-flex">
                <img src="/assets/imgs/theme/icons/icon-headphone.svg" alt="hotline" />
                <p>8828485299<span>24/7 Support Center</span></p>
              </div>
              <div className="header-action-icon-2 d-block d-lg-none">
                <div className="burger-icon burger-icon-white">
                  <span className="burger-icon-top"></span>
                  <span className="burger-icon-mid"></span>
                  <span className="burger-icon-bottom"></span>
                </div>
              </div>
              <div className="header-action-right d-block d-lg-none">
                <div className="header-action-2">
                  <div className="header-action-icon-2">
                    <a href="shop-wishlist">
                      <img alt="Nest" src="/assets/imgs/theme/icons/icon-heart.svg" />
                      <span className="pro-count white">4</span>
                    </a>
                  </div>
                  <div className="header-action-icon-2">
                    <Link className="mini-cart-icon" to="/shop-cart">
                      <img alt="Nest" src="/assets/imgs/theme/icons/icon-cart.svg" />
                      <span className="pro-count white">{cartCount}</span>
                    </Link>
                    <div className="cart-dropdown-wrap cart-dropdown-hm2">
                      {cartItems.length ? (
                        <ul>
                          {cartItems.slice(0, 3).map((item) => (
                            <li key={item.ProductId}>
                              <div className="shopping-cart-img">
                                <Link to={`/product-detail/${item.ProductId}`}><ProductImage alt={item.ProductName} src={item.DefaultImage} /></Link>
                              </div>
                              <div className="shopping-cart-title">
                                <h4><Link to={`/product-detail/${item.ProductId}`}>{item.ProductName}</Link></h4>
                                <h3><span>{item.quantity} × </span><i className="fa fa-inr fs-10" aria-hidden="true"></i>{item.Price}</h3>
                              </div>
                              <div className="shopping-cart-delete">
                                <button
                                  type="button"
                                  className="border-0 bg-transparent p-0"
                                  onClick={() => removeFromCart(item.ProductId)}
                                >
                                  <i className="fi-rs-cross-small"></i>
                                </button>
                              </div>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <div className="p-3 text-center">Your cart is empty.</div>
                      )}
                      <div className="shopping-cart-footer">
                        <div className="shopping-cart-total">
                          <h4>Total <span><i className="fa fa-inr fs-10" aria-hidden="true"></i>{cartTotal.toLocaleString('en-IN')}</span></h4>
                        </div>
                        <div className="shopping-cart-button">
                          <Link to="/shop-cart">View cart</Link>
                          <Link to="/shop-checkout">Checkout</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;